import { render, staticRenderFns } from "./tag-list-selector.html?vue&type=template&id=0aebbc9c&scoped=true&"
import script from "./tag-list-selector.js?vue&type=script&lang=js&"
export * from "./tag-list-selector.js?vue&type=script&lang=js&"
import style0 from "./tag-list-selector.scss?vue&type=style&index=0&id=0aebbc9c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aebbc9c",
  null
  
)

export default component.exports